import { egyptsResearch } from "../../../../data/research/egypts"
import { hunsResearch } from "../../../../data/research/huns"
import { romanResearch} from "../../../../data/research/roman"
import { gallicResearch} from "../../../../data/research/gallic"
import { teutonicResearch} from "../../../../data/research/teutonic"
import { spartansResearch} from "../../../../data/research/spartans"
import ListSelect from "../../ListSelect"
import { train } from "../../../../data/selectOptions"
import { useState } from "react"
import Btn from "../../Btn"


const Research = (props) => {

    //SELECTLISTY
    const selectList = train 
    const selectListHunResearch = hunsResearch.map((hun, index) => ({
        id : index + 1,
        name : hun.name
    }))
    const selectListEgyptResearch = egyptsResearch.map((egypt, index) => ({
        id : index + 1,
        name : egypt.name
    }))
    const selectListRomanResearch = romanResearch.map((roman, index) =>({
        id : index + 1,
        name : roman.name
    }))
    const selectListGallicResearch = gallicResearch.map((gallic, index) => ({
        id : index + 1,
        name : gallic.name
    }))
    const selectListTeutonicResearch = teutonicResearch.map((teutonic, index) =>({
        id : index + 1,
        name : teutonic.name
    }))
    const selectListSpartanResearch = spartansResearch.map((spartan, index) =>({
        id : index + 1,
        name : spartan.name
    }))
    //

    const [selectValue, setSelectValue] = useState({nation:"", trop:""})
    const handleSelectValueNation = event => {
        setSelectValue(prevState => ({ nation: event.target.value, trop: prevState.trop }));
    }
    const handleSelectValueTrop = event => {
        setSelectValue(prevState => ({ ...prevState, trop: event.target.value }));
    }

    function vypis() {
        let item
        if (selectValue.nation ==="1") {item = hunsResearch[selectValue.trop - 1] }
        if (selectValue.nation ==="2") {item = egyptsResearch[selectValue.trop - 1] }
        if (selectValue.nation ==="3") {item = romanResearch[selectValue.trop - 1] }
        if (selectValue.nation ==="4") {item = gallicResearch[selectValue.trop - 1] }
        if (selectValue.nation ==="5") {item = teutonicResearch[selectValue.trop - 1] }
        if (selectValue.nation ==="6") {item = spartansResearch[selectValue.trop - 1] }
        props.addItem(item)
        
    }


    return (
        <>
            <ListSelect label ="...choose a nation..."selectList={selectList} handleSelectValue={handleSelectValueNation}/>
            {selectValue.nation ==="1" ? (
                <>
                    <ListSelect label="choose a trop..." selectList={selectListHunResearch} handleSelectValue={handleSelectValueTrop}/>
                    {selectValue.trop !== "" ? (
                        <Btn className="btn" type="submit" text="Add to result" onClick={vypis} />                        
                    ) : null}
                </>
            ) :
            selectValue.nation ==="2" ? (
                <>
                    <ListSelect label="choose a trop..." selectList={selectListEgyptResearch} handleSelectValue={handleSelectValueTrop}/>
                    {selectValue.trop !== "" ? (
                        <Btn className="btn" type="submit" text="Add to result" onClick={vypis} />                        
                    ) : null}
                </>
            ) :
            selectValue.nation ==="3" ? (
                <>
                    <ListSelect label="choose a trop..." selectList={selectListRomanResearch} handleSelectValue={handleSelectValueTrop}/>
                    {selectValue.trop !== "" ? (
                        <Btn className="btn" type="submit" text="Add to result" onClick={vypis} />                        
                    ) : null}
                </>
            ) :
            selectValue.nation ==="4" ? (
                <>
                    <ListSelect label="choose a trop..." selectList={selectListGallicResearch} handleSelectValue={handleSelectValueTrop}/>
                    {selectValue.trop !== "" ? (
                        <Btn className="btn" type="submit" text="Add to result" onClick={vypis} />                        
                    ) : null}
                </>
            ) :
            selectValue.nation ==="5" ? (
                <>
                    <ListSelect label="choose a trop..." selectList={selectListTeutonicResearch} handleSelectValue={handleSelectValueTrop}/>
                    {selectValue.trop !== "" ? (
                        <Btn className="btn" type="submit" text="Add to result" onClick={vypis} />                        
                    ) : null}
                </>
            ) :
            selectValue.nation ==="6" ? (
                <>
                    <ListSelect label="choose a trop..." selectList={selectListSpartanResearch} handleSelectValue={handleSelectValueTrop}/>
                    {selectValue.trop !== "" ? (
                        <Btn className="btn" type="submit" text="Add to result" onClick={vypis} />                        
                    ) : null}
                </>
            ) : null }
        </>
    )

}
export default Research